export const imageUrlToImageData = async (imageUrl) => {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.crossOrigin = 'Anonymous'

    img.onload = () => {
      const canvas = document.createElement('canvas')
      canvas.width = img.width
      canvas.height = img.height
      const ctx = canvas.getContext('2d')
      ctx.drawImage(img, 0, 0)
      const imageData = ctx.getImageData(0, 0, img.width, img.height)

      resolve(imageData)
    }

    img.onerror = (error) => {
      reject(error)
    }

    img.src = imageUrl
  })
}

export const getImageDataSizeInKB = (imageData) => {
  // Get the size of the image data in bytes
  const dataSizeInBytes = imageData.data.length * Uint8Array.BYTES_PER_ELEMENT;

  // Convert bytes to kilobytes
  const dataSizeInKB = dataSizeInBytes / 1024;

  return dataSizeInKB;
}


export const isSupportedImageType = (file) => {
  const mimeType = file.type
  // Supported image MIME types
  const supportedTypes = [
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/bmp',
  ]

  return supportedTypes.includes(mimeType)
}

export const isWithinSizeLimit = (file) => {
  const maxSizeInBytes = 15 * 1024 * 1024 // 15 MB
  const fileSizeInBytes = file.size
  const maxSizeInBytesLimit = maxSizeInBytes * 1024 * 1024 // Convert MB to bytes

  return fileSizeInBytes <= maxSizeInBytesLimit
}
